import { createAction } from 'redux-actions';

import { POST_ALLEYE_SALES, LOADING_ALLEYE_SALES } from './consts';

export const postAlleyeSales = createAction(POST_ALLEYE_SALES);
export const setIsLoadingAlleyeSales = createAction(LOADING_ALLEYE_SALES);
